import axios from 'axios';

// export const devBaseUrl = 'https://api.tyrebase.ru/api';
export const devBaseUrl = 'http://localhost/api';
export const prodBaseUrl = 'https://api.tyrebase.ru/api';



export const api = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? devBaseUrl : prodBaseUrl,
});
//api.defaults.headers.common.accept = 'application/json';
